import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
  country: null,
  state: null,
  city: null,
  dateRange: {
    startDate: moment().subtract(29, "days"),
    endDate: moment(),
  },
  defaultDateRange: {
    startDate: moment().subtract(29, "days"),
    endDate: moment(),
  },
  utm_payload: {
    utm_campaign: null,
    utm_content: null,
    utm_medium: null,
    utm_name: null,
    utm_source: null,
    utm_term: null,
  },
  utm_options: {
    utm_campaign: [],
    utm_content: [],
    utm_medium: [],
    utm_name: [],
    utm_source: [],
    utm_term: []
  },
  searchTerm: null,
  gender: null,
  isIosUser: null,
  profileCompilation: null,
  duration: "Monthly",
  activeVerificationTab: "Total Verification Requests",
  isBot: false,
  statsType: null,
  statsTitle: null,
  locationStatsType: "active_users"
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setCountryFilter(state, action) {
      state.country = action.payload.country;
    },
    setStateFilter(state, action) {
      state.state = action.payload.state;
    },
    setCityFilter(state, action) {
      state.city = action.payload.city;
    },
    setDateFilter(state, action) {
      state.dateRange = action.payload.dateRange;
    },
    setGenderFilter(state, action) {
      state.gender = action.payload.gender;
    },
    setBotFilter(state, action) {
      state.isBot = action.payload.isBot;
    },
    setIosUserFilter(state, action) {
      state.isIosUser = action.payload.isIosUser;
    },
    setUTMFilter(state, action) {
      const payload = action.payload;
      // Update only matching keys in utm_payload
      Object.keys(payload).forEach((key) => {
        if (key in state.utm_payload) {
          state.utm_payload[key] = payload[key];
        }
      });
    },
    setUtmOptions(state, action) {
      state.utm_options = action.payload
    },
    setDurationFilter(state, action) {
      state.duration = action.payload.duration;
    },
    setActiveVerificationTab(state, action) {
      state.activeVerificationTab = action.payload.activeVerificationTab;
    },
    setSearchTermAction(state, action) {
      state.searchTerm = action.payload.searchTerm;
    },
    setProfileCompilationFilter(state, action) {
      state.profileCompilation = action.payload.profileCompilation;
    },
    setStatsTypeFilter(state, action) {
      if (action.payload) {
        Object.assign(state, action.payload);
      }
    },
    setLocationStatsTypeFilter(state, action) {
      state.locationStatsType = action.payload.locationStatsType;
    },
    setResetFilter(state) {
      state.country = initialState.country;
      state.state = initialState.state;
      state.city = initialState.city;
      state.searchTerm = initialState.searchTerm;
      // state.dateRange = {
      //   startDate: moment().subtract(29, 'days'),
      //   endDate: moment(),
      // };
      state.gender = initialState.gender;
      state.duration = initialState.duration;
      state.activeVerificationTab = initialState.activeVerificationTab;
      state.isBot = initialState.isBot;
      state.isIosUser = initialState.isIosUser;
      state.utm_payload = initialState.utm_payload;
      state.profileCompilation = initialState.profileCompilation;
      state.statsType = initialState.statsType;
      state.statsTitle = initialState.statsTitle;
      state.locationStatsType = initialState.locationStatsType;
      // state.utm_options = initialState.utm_options
    },
  },
});

export const {
  setCountryFilter,
  setStateFilter,
  setCityFilter,
  setDateFilter,
  setGenderFilter,
  setProfileCompilationFilter,
  setDurationFilter,
  setResetFilter,
  setActiveVerificationTab,
  setUTMFilter,
  setBotFilter,
  setIosUserFilter,
  setUtmOptions,
  setSearchTermAction,
  setStatsTypeFilter,
  setLocationStatsTypeFilter,
} = filterSlice.actions;
export default filterSlice.reducer;
